import { Component } from '@angular/core';
import {InfoCardComponent} from "../../../../../utils/components/info-card/info-card.component";
import {CloseableDialogComponent} from '../../../../../utils/components/closeable-dialog/closeable-dialog.component';
import {MatDialogContent} from '@angular/material/dialog';

@Component({
  selector: 'app-search-settings-database-overview-dialog',
  imports: [
    InfoCardComponent,
    CloseableDialogComponent,
    MatDialogContent
  ],
  templateUrl: './search-settings-database-overview-dialog.component.html',
  styleUrl: './search-settings-database-overview-dialog.component.scss',
})
export class SearchSettingsDatabaseOverviewDialogComponent {

}
